import { Table, TableHead, TableRow } from '@mui/material';
import { useFetchInstrumentProofreadEventsApi } from 'api/mypage/instruments/proofread_events';
import Modal, { ModalSet } from 'components/shared/modal';
import { ExTableBody, ExTableCell } from 'components/shared/table';
import ThemedButton from 'components/shared/themed_button';
import { ProofreadEvent } from 'entities/proofread_event';
import React from 'react';
import { useEffectSkipFirst } from 'utils/hooks';
import { ProofreadEventViewModel } from 'view_models/proofread_event';

type EventHistoryModalProps = {
  modalSet: ModalSet<ProofreadEvent>;
};
export const EventHistoryModal: React.FC<EventHistoryModalProps> = (props) => {
  const indexApi = useFetchInstrumentProofreadEventsApi(props.modalSet.item.instrumentId);

  useEffectSkipFirst(() => {
    indexApi.execute();
  }, [props.modalSet.item.id]);

  return (
    <Modal
      modalId="event-history-modal"
      modalState={props.modalSet.modalState}
      title="過去の校正"
      size="lg"
      subTitle={props.modalSet.item.instrument?.instrumentBasicInfo?.name || ''}
      footer={
        <>
          <ThemedButton onClick={props.modalSet.closeModal} color="secondary">
            閉じる
          </ThemedButton>
        </>
      }
    >
      <Table>
        <TableHead>
          <TableRow>
            <ExTableCell>校正月</ExTableCell>
            <ExTableCell>校正価格</ExTableCell>
            <ExTableCell>委託先</ExTableCell>
            <ExTableCell>担当者</ExTableCell>
            <ExTableCell>ステータス</ExTableCell>
          </TableRow>
        </TableHead>
        <ExTableBody loading={indexApi.loading}>
          {indexApi.response.proofreadEvents
            .filter((e) => e.proofreadPlanId !== props.modalSet.item.proofreadPlanId)
            .map((event) => {
              const eventVm = new ProofreadEventViewModel(event);
              return (
                <TableRow key={event.id}>
                  <ExTableCell>{eventVm.getScheduledDate()}</ExTableCell>
                  <ExTableCell>{eventVm.getPrice()}</ExTableCell>
                  <ExTableCell>{eventVm.getSupplier()}</ExTableCell>
                  <ExTableCell>{eventVm.getUser()}</ExTableCell>
                  <ExTableCell>{eventVm.getStatusLabel()}</ExTableCell>
                </TableRow>
              );
            })}
        </ExTableBody>
      </Table>
    </Modal>
  );
};

export default EventHistoryModal;
